import React from "react";
import { Link } from "react-router-dom";

export default function BreadCrumb({ heading }) {
  return (
    <>
      {/* breadcrumbarea__section__start */}
      <div className="breadcrumbarea">
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="breadcrumb__content__wraper" data-aos="fade-up">
                <div className="breadcrumb__title">
                  <h2 className="heading">{heading}</h2>
                </div>
                <div className="breadcrumb__inner">
                  <ul>
                    <li>
                      <Link to="/">Home</Link>
                    </li>
                    <li>{heading}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="shape__icon__2">
          <img
            loading="lazy"
            className=" shape__icon__img shape__icon__img__1"
            src="/assets/img/herobanner/herobanner__1.png"
            alt="hero"
          />
          <img
            loading="lazy"
            className=" shape__icon__img shape__icon__img__2"
            src="/assets/img/herobanner/herobanner__2.png"
            alt="hero"
          />
          <img
            loading="lazy"
            className=" shape__icon__img shape__icon__img__3"
            src="/assets/img/herobanner/herobanner__3.png"
            alt="hero"
          />
          <img
            loading="lazy"
            className=" shape__icon__img shape__icon__img__4"
            src="/assets/img/herobanner/herobanner__5.png"
            alt="hero"
          />
        </div>
      </div>
      {/* breadcrumbarea__section__end*/}
    </>
  );
}
